import { Button, Input, Space, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useCreateTicket } from './store';
import _ from 'lodash';
import { getFormattedDate, specialSubCategories } from 'modules/utilities/utility';
const { Text } = Typography;
import moment from 'moment';
import { toast } from 'react-toastify';
import { CATEGORY } from 'modules/my_tickets/data';
const { MEDICAL_ESCALATIONS, CUSTOMER_COMPLAINTS } = CATEGORY;
import { createMeidcalEscalationTicket } from 'modules/navbar/top/store';

const CreateTicketFooter = ({ ticketPayload, validation, slotBookingPayload }) => {
    const { createTicket, ticketLoading, ticketResponse } = useCreateTicket();
    const { nearestSlot } = createMeidcalEscalationTicket();
    const [slotTime, setSlotTime] = useState(null);

    useEffect(() => {
        const slotTime = _.get(ticketResponse, ['medical_slot_time'], null)
        let time = slotTime ? getFormattedDate(slotTime) : slotTime
        setSlotTime(time)
    }, [ticketResponse]);

    const onCreateTicket = () => {
        const payload = { ...ticketPayload };
        if (ticketPayload.category === CUSTOMER_COMPLAINTS) {
            payload.slotBooking = slotBookingPayload;
            const slotTime = _.get(payload, ["slotBooking", "slotTime"], false);
            if (slotTime && moment(slotTime).isBefore(moment())) {
                toast.error(`This slot has passed. Please select new slot.`);
                return;
            }
        }
        if (ticketPayload.category === MEDICAL_ESCALATIONS) {
            payload.slotBooking = slotBookingPayload;
            const slotTime = _.get(payload, ["slotBooking", "slotTime"], false);
            if (slotTime && moment(slotTime).isBefore(moment())) {
                toast.error(`This slot has passed. Please select new slot.`);
                return;
            }
        }
        if(specialSubCategories.includes(ticketPayload.sub_category)){
            ticketPayload.medical_slot_time = nearestSlot.slot_time;
        }
        createTicket(payload);
    };

    return (
        <div className='bottom-0 border border-1 p-3 d-flex justify-flex-between align-items-center gap-4' >
            <Button
                disabled={ticketLoading || validation && _.size(Object.values(validation)) === 0 || _.size(Object.values(validation).filter(key => !key))}
                onClick={onCreateTicket}>
                Create Ticket
            </Button>

            {[MEDICAL_ESCALATIONS, CUSTOMER_COMPLAINTS].includes(ticketPayload.category) && <Space.Compact block className='my-3'>
                <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }}
                    className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
                    <Text>Slot Booked</Text>
                </span>
                <Input style={{ width: '70%' }} value={slotTime} />
            </Space.Compact>}
        </div >
    )
}

export default CreateTicketFooter